import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './account/services/user.service';
import { AuthService } from './auth/auth.service';
import { DrawerService } from './drawer/services/drawer.service';
import { StorageService } from './services/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent, DialogData } from './components/dialog/dialog.component';

interface RouterItem {
  routerLink: string;
  icon: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  navBarTitle: string = ``;
  title = 'church-web';
  showDrawer = false;
  userName;
  userAvatar = null;
  isMobile = innerWidth <= 600;

  routers = {
    home: 'home.svg',
    membro: 'people.svg',
    area: 'people.svg',
    setor: 'sector.svg',
    celula: 'groups.svg',
    patrimonio: 'patrimony.svg',
    frequencia: 'frequency.svg',
    dashboard: 'home.svg',
    palavra: 'article.svg',
    crianca: 'child.svg',
    permissoes: 'child.svg',
    devocional: 'quiz.svg',
  };

  constructor(
    private router: Router,
    private userService: UserService,
    private activatedRouter: ActivatedRoute,
    private storage: StorageService,
    private drawerService: DrawerService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}
}
